import api from '../configs/api';
import jwt_decode from 'jwt-decode';
import { TJWTProfile, TUserCredentials } from '../types/auth';
export const validateJwtToken = function (token: any): TJWTProfile | null {
    try {
        console.log(jwt_decode(token));
        return jwt_decode(token);
    } catch (e) {
        return null;
    }
};
export default {
    login: (uc: TUserCredentials) => api.post('auth/login', JSON.stringify(uc)),
    logout: () =>
        api.post(
            'auth/logout',
            JSON.stringify({
                userId: validateJwtToken(localStorage.getItem('accessToken'))?.id,
                refreshToken: localStorage.getItem('refreshToken')
            })
        ),
    isLogin: validateJwtToken(localStorage.getItem('accessToken')) ? true : false,
    getUser: validateJwtToken(localStorage.getItem('accessToken'))
};
